'use client';

import React from 'react';
import FAQSection from '@/components/Faq/FAQSection';
import DefaultLayout from '@/layouts/DefaultLayout';
import withLayout from './hoc/withLayout';
import Button from '@/components/Button/Button';
import { useRouter } from 'next/navigation';
import { T } from '@tolgee/react';
const NotFoundPage = () => {
  const router = useRouter();
  return <>
      <div className="p-8 bg-primary">
        <div className="p-16 bg-[url('/img/404.svg')] bg-no-repeat bg-center bg-cover">
          <div className="w-full text-white">
            <div className="w-3/5">
              <h1 className="text-[100px] font-semibold tracking-headerTight leading-tight mb-20">
                <T data-sentry-element="T" data-sentry-source-file="not-found.tsx">404.404.label</T>
              </h1>
              <p className="text-6xl font-semibold tracking-headerTight leading-tight mt-2">
                <T data-sentry-element="T" data-sentry-source-file="not-found.tsx">404.title.label</T>
              </p>
              <p className="text-4xl font-poppins leading-tight tracking-tightest mt-4">
                <T data-sentry-element="T" data-sentry-source-file="not-found.tsx">404.subtitle.label</T>
              </p>
              <div className="flex mt-6 space-x-2">
                <Button variant="primary" onClick={() => router.back()} fullWidth={false} data-sentry-element="Button" data-sentry-source-file="not-found.tsx">
                  <T data-sentry-element="T" data-sentry-source-file="not-found.tsx">404.button.back.label</T>
                </Button>
                <Button variant="secondary" href="/" fullWidth={false} data-sentry-element="Button" data-sentry-source-file="not-found.tsx">
                  <T data-sentry-element="T" data-sentry-source-file="not-found.tsx">404.button.home.label</T>
                </Button>
              </div>
            </div>
          </div>
        </div>
      </div>
      <FAQSection data-sentry-element="FAQSection" data-sentry-source-file="not-found.tsx" />
    </>;
};
export default withLayout(NotFoundPage, props => <DefaultLayout {...props} showCategoryNav={false} showFooter={false} />);